<app-grid-client-side
    #appHistoryProductsDeletedComponent
    [headerCheckboxSelection]="true"
    [tableData]="tableData[0]"
    (rowClicked)="rowClicked($event)"
    (filterChangedEmitter)="onFilterChanged()"
    [fixedButtons]="fixedButtons"
    [exportFormatterOptions]="exportFormatterOptions"
    feature="history_products_deleted">
</app-grid-client-side>